import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import axios from "../../../config/authAxios"



const initialState = { status: null, loading: false, data: [], error: "", message: "" }


export const isActivePartnerAction = createAsyncThunk(
    'is-active-partner',
    async (data, { rejectWithValue }) => {
       
        try {
            const res = await axios.put(`/admins/api/make-partner-active`,data)
            return res?.data
        } catch (error) {
            return rejectWithValue(error.response.data)
        }
    }
)


export const isActivePartnerSlice = createSlice({
    name: 'is-active-partner',
    initialState,
    reducers: {},
    extraReducers:
        (builder) => {
            builder.addCase(isActivePartnerAction.pending, (state) => {
                state.loading = true
            })
            builder.addCase(isActivePartnerAction.fulfilled, (state, action) => {
                state.loading = false
                state.data = action?.payload?.data
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
            builder.addCase(isActivePartnerAction.rejected, (state, action) => {
                state.loading = false
                state.error = action?.payload?.error
                state.status = action?.payload?.status
                state.message = action?.payload?.message
            })
        },

})



export const isActivePartnerReducer = isActivePartnerSlice.reducer    